<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
<div class="text-lg mb-5">Fee Assessment</div>
<!-- Search Form (Matching Background) -->
<form class="flex bg-fieldset py-2 px-4 mb-3" [formGroup]="searchFormGrp" (ngSubmit)="searchHandler()">


  <!-- Label above input box -->


  <!-- Inline Input & Buttons -->
  <div class="flex items-center space-x-6">
    <div class="flex flex-col mr-8">
      <mat-label>Document ID</mat-label>
      <mat-form-field class="w-full" appearance="outline">
        <input matInput type="text" formControlName="caseNumber" placeholder="Enter Document ID" class="h-6 text-sm"
          [value]="feecaseData()?.docId || searchFormGrp.get('caseNumber')?.value || ''" />
        <mat-error *ngIf="searchFormGrp.get('caseNumber')?.hasError('required')" style="white-space: nowrap;">
          Please enter the Document ID to search
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Buttons in the same line -->
    <button type="reset" color="primary" class="mr-4" (click)="resetHandler()">Reset</button>
    <button type="submit" mat-flat-button color="primary">Search</button>
  </div>
</form>




<div *ngIf="isLoading()" class="flex justify-center">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<!-- Fee Assessment -->
<div class="p-2 border rounded-lg bg-fieldset mt-2" *ngIf="feecaseData() && !isLoading()">

  <!-- Fee Assessment Header with Divider -->
  <!-- Fee Assessment Header with Buttons on Right -->
  <div class="flex justify-between items-center mb-2">
    <h3 class="text-lg font-semibold">Fee Assessment</h3>

    <div class="flex space-x-2">
      <button *ngIf="!isEditing()" mat-button color="primary" (click)="onPrint()">
        <mat-icon fontIcon="print" class="mr-1"></mat-icon>Print
      </button>

      <button mat-button color="primary" (click)="isEditing() ? getconfirmation('Save') : toggleEdit()"
        [disabled]="isEditing() && (!feeForm.valid || feeForm.value.feeAmount == 0)">
        <mat-icon fontIcon="{{ isEditing() ? 'save' : 'edit' }}" class="mr-1"></mat-icon>
        {{ isEditing() ? 'Save' : 'Edit' }}
      </button>

      <button *ngIf="isEditing()" mat-button color="warn" (click)="cancelEdit()">
        <mat-icon fontIcon="cancel" class="mr-1"></mat-icon>Cancel
      </button>
    </div>
  </div>


  <!-- Divider Line -->
  <div class="border-b my-2"></div>

  <!-- First Row: Case Details (Reduced Horizontal Gap) -->
  <div class="grid grid-cols-3 gap-x-2 gap-y-2">
    <div>
      <mat-label style=" color: gray;">Document ID</mat-label>
      <p>{{ feecaseData()?.docId || '-' }}</p>
    </div>
    <div>

      <mat-label style=" color: gray;">Case/ Appeal Number</mat-label>
      <p>{{ feecaseData()?.caseNumber }}</p>
    </div>
    <div>
      <mat-label style=" color: gray;">Task ID</mat-label>
      <p>{{ feecaseData()?.taskId || '-' }}</p>
    </div>
  </div>

  <!-- Form Section -->
  <form [formGroup]="feeForm" class="space-y-2 mt-8">

    <!-- Second Row: Fee Amount & No of Pages (Reduced Horizontal Gap) -->
    <div class="grid grid-cols-3 gap-x-2 gap-y-2">
      <div>
        <mat-label class="required-label">Fee Amount (Naira)</mat-label>
        <mat-form-field class="w-full">
          <input type="number" formControlName="feeAmount" matInput />
          <mat-error *ngIf="feeForm.get('feeAmount')?.hasError('required')">
            This field is required
          </mat-error>
          <mat-error *ngIf="feeForm.get('feeAmount')?.hasError('nonZero')">
            Amount cannot start with 0
          </mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-label class="required-label">No of Pages</mat-label>
        <mat-form-field class="w-full">
          <input type="number" formControlName="pages" matInput />
          <mat-error *ngIf="feeForm.get('pages')?.hasError('required')">
            This field is required
          </mat-error>
          <mat-error *ngIf="feeForm.get('pages')?.hasError('nonZero')">
            Pages cannot start with 0
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Third Row: Larger Remarks Box (Extending to End of No of Pages) -->
    <div class="grid grid-cols-3 gap-x-2">
      <div class="col-span-2"> <!-- Spans 2 columns to match Fee Amount + No of Pages -->
        <mat-label [class.required-label]="feeForm.get('governmentParty')?.value">
          Remarks
        </mat-label>
        <mat-form-field class="w-full">
          <textarea rows="3" formControlName="remarks" matInput></textarea>
          <mat-error *ngIf="feeForm.get('remarks')?.hasError('required')">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>